import { Component } from '@angular/core'
import { AuthenticationService } from '@services/authentication.service'
import { SubscriptionService } from '@services/subscription.service'

@Component({
  selector: 'shared-resource-limit-alert',
  templateUrl: './resource-limit-alert.component.html',
  styleUrls: ['./resource-limit-alert.component.css'],
  standalone: false
})
export class ResourceLimitAlertComponent {
  get atFileLimit() { return this._subscriptionService.atFileLimit }
  get atRealityAssetLimit() { return this._subscriptionService.atRealityAssetLimit }
  get hasUserAdminAccess() { return this._authService.hasUserAdminAccess }
  get inProTier() { return this._subscriptionService.inProTier }
  get limitReached() { return this.atFileLimit || this.atRealityAssetLimit }

  constructor(private _authService: AuthenticationService, private _subscriptionService: SubscriptionService) { }
}